export function calculateClubPoints(club = {}) {
  return Number(club?.operationalPoints || 0) + Number(club?.bonusPoints || 0);
}

function competitionTotalsFor(club, competitions = []) {
  return competitions
    .filter((competition) => competition?.status === "completed")
    .filter((competition) => competition?.division === "all" || !competition?.division || String(competition.division).toLowerCase() === String(club?.division || "gold").toLowerCase())
    .reduce((totals, competition) => {
      const winner = (competition.winners || []).find((entry) => entry.siteId === club.id);
      const points = winner ? Number(winner.points || 0) : Number(competition.participationPoints || 0);
      return {
        points: totals.points + points,
        played: totals.played + 1,
        won: totals.won + (Number(winner?.place) === 1 ? 1 : 0),
      };
    }, { points: 0, played: 0, won: 0 });
}

export function buildStandings(clubs = [], season = {}, competitions = []) {
  const useCompetitionLedger = competitions.some((competition) => competition?.status === "completed");
  return [...clubs]
    .filter((club) => club?.active !== false)
    .map((club) => {
      const ledger = competitionTotalsFor(club, competitions);
      const operationalPoints = useCompetitionLedger ? ledger.points : Number(club?.operationalPoints || 0);
      const played = useCompetitionLedger ? ledger.played : Number(club?.played || 0);
      const won = useCompetitionLedger ? ledger.won : Number(club?.won || 0);
      return {
        ...club,
        played,
        won,
        drawn: Number(club?.drawn || 0),
        lost: Number(club?.lost || 0),
        points: operationalPoints + Number(club?.bonusPoints || 0),
        operationalPoints,
        goalsFor: Number(club?.goalsFor || 0),
        goalsAgainst: Number(club?.goalsAgainst || 0),
        goalDifference: Number(club?.goalsFor || 0) - Number(club?.goalsAgainst || 0),
      };
    })
    .sort((a, b) =>
      b.points - a.points ||
      b.operationalPoints - a.operationalPoints ||
      b.won - a.won ||
      String(a.name || "").localeCompare(String(b.name || ""))
    )
    .map((club, index) => ({ ...club, position: index + 1 }));
}
